import React from 'react';

const ReportsContext = React.createContext('reports');

export const ReportsContextProvider = ReportsContext.Provider;

export default ReportsContext;
